import React, { useEffect } from "react";
import LinkedinLogo from "../../assets/icons/linkedin-logo.svg";
import classes from "./Team.module.css";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

function Team(props) {
  const [fade, api] = useSpring(() => ({
    translateX: 100,
    config: { delay: 500, duration: 2000 },
  }));

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      api.start({
        translateX: 0,
        config: { delay: 500, duration: 1500 },
      });
    }
  }, [api, inView]);

  return (
    <animated.figure className={classes.Team} ref={ref} style={fade}>
      <img className={classes.TeamUserImg} src={props.src} alt="" />
      <div className={classes.TeamUser}>
        <div>
          <p className={classes.TeamUserName}>{props.name}</p>
          <p className={classes.TeamUserPosition}>{props.position}</p>
        </div>

        <a href={`https://www.linkedin.com/in/${props.link}/`} target="/">
          <img
            src={LinkedinLogo}
            alt="Linkedin Logo"
            className={classes.LinkdeinLogo}
          />
        </a>
      </div>
    </animated.figure>
  );
}

export default Team;
